/**
 * curatedJourneys.js
 *
 * Three teacher-designed, fixed-order curated journey sequences.
 * Each journey is an ordered array of level IDs.
 */

export const CURATED_JOURNEYS = [
  {
    id: 'foundation',
    name: 'Foundation',
    emoji: '🏛️',
    tagline: 'The complete Sargam journey',
    description: 'A methodical path through every note — holds, doubles, ascending and descending. Designed by our music teacher cofounder.',
    color: '#c0773c',
    gradient: 'linear-gradient(135deg, #c0773c 0%, #e8a857 50%, #f7d98b 100%)',
    glowColor: 'rgba(192,119,60,0.55)',
    levelIds: [1, 101, 11, 12, 2, 3, 4, 19, 20, 21, 22, 24, 108, 31, 13, 102, 103, 104, 109, 110, 111, 23, 112, 113, 114, 115, 116, 117, 118, 119, 120, 121, 10, 122, 123, 124, 125, 126, 99, 127, 128, 129, 130, 131, 100],
  },
  {
    id: 'ascending',
    name: 'Ascending',
    emoji: '⬆️',
    tagline: 'Master the upward scale',
    description: "From single holds to full ascending chains — windows, skips, and staccato runs. A purist's guide to the aroha.",
    color: '#2e7d32',
    gradient: 'linear-gradient(135deg, #1b5e20 0%, #388e3c 50%, #81c784 100%)',
    glowColor: 'rgba(46,125,50,0.55)',
    levelIds: [1, 101, 11, 12, 13, 102, 103, 104, 2, 3, 4, 6, 8, 9, 10, 124, 37, 38, 39, 40, 41, 42, 132, 53, 54, 55, 56, 133, 134, 135, 136, 137, 138, 139, 140, 141, 142, 143, 144, 145, 146, 147, 148, 149, 150, 151, 152, 153],
  },
  {
    id: 'descending',
    name: 'Descending',
    emoji: '⬇️',
    tagline: 'Master the downward flow',
    description: 'Mirror of the ascending path — descend from Sa (Taar) through every note, group, and skip. The avaroh awaits.',
    color: '#1565c0',
    gradient: 'linear-gradient(135deg, #0d47a1 0%, #1976d2 50%, #64b5f6 100%)',
    glowColor: 'rgba(21,101,192,0.55)',
    levelIds: [104, 103, 102, 13, 12, 11, 101, 1, 115, 116, 117, 118, 119, 120, 121, 125, 48, 47, 46, 43, 44, 45, 154, 155, 59, 58, 57, 60, 156, 157, 158, 159, 160, 161, 162, 88, 89, 90, 163, 164, 165, 166, 167, 168, 169, 170, 171],
  },
];

/** Convenience map: journey id → journey object */
export const CURATED_JOURNEY_MAP = Object.fromEntries(
  CURATED_JOURNEYS.map((j) => [j.id, j])
);
